import { Box } from '@mui/material';
import React from 'react';

const QuoteIcon = ({ boxSize, disabled }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg
        width={boxSize}
        height={boxSize}
        viewBox="0 0 27 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7681_33015)">
          <path
            d="M18.5657 6.80014L13.7657 2.05821C13.6286 1.92272 13.4914 1.85498 13.2857 1.85498H6.42856C5.67427 1.85498 5.05713 2.46466 5.05713 3.20982V19.4679C5.05713 20.213 5.67427 20.8227 6.42856 20.8227H17.4C18.1543 20.8227 18.7714 20.213 18.7714 19.4679V7.27433C18.7714 7.07111 18.7028 6.93563 18.5657 6.80014ZM13.2857 3.48079L17.1257 7.27433H13.2857V3.48079ZM17.4 19.4679H6.42856V3.20982H11.9143V7.27433C11.9143 8.0195 12.5314 8.62917 13.2857 8.62917H17.4V19.4679Z"
            fill={disabled ? 'lightgrey' : 'black'}
          />
        </g>
        <ellipse
          cx="20.1429"
          cy="14.0484"
          rx="6.17143"
          ry="6.09677"
          fill={disabled ? 'lightgrey' : '#037836'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.5165 10.9664L23.2624 11.7033C23.6744 12.1102 23.6744 12.7701 23.2624 13.1771L22.6283 13.8034L20.3906 11.5927L21.0246 10.9664C21.4366 10.5594 22.1045 10.5594 22.5165 10.9664ZM20.0176 11.9612L17.1598 14.7845C16.9899 14.9524 16.883 15.1725 16.857 15.4085L16.7185 16.6653C16.6698 17.1066 17.047 17.4792 17.4937 17.4311L18.7658 17.2943C19.0047 17.2686 19.2276 17.1631 19.3975 16.9952L22.2554 14.1719L20.0176 11.9612Z"
          fill="white"
        />
        <defs>
          <clipPath id="clip0_7681_33015">
            <rect
              width="21.9429"
              height="21.6774"
              fill="white"
              transform="translate(0.942871 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </Box>
  );
};

export default QuoteIcon;
